import styled from 'styled-components';
import UITable from 'UIComponents/table/UITable';
import { getAuditEventTypes } from 'automation-ui-management/records/AuditHistory/utils';
import pairUp from 'automation-ui-management/utils/pairUp';
import RevisionRollupInsetTableRow from 'automation-ui-management/revision-rollup-panel/RevisionRollupInsetTableRow';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ALIGNED_TIMESTAMP_COLUMN_WIDTH = 200;
const InsetTableWrapper = styled.div.withConfig({
  displayName: "RevisionRollupInsetTable__InsetTableWrapper",
  componentId: "r0hitz-0"
})(({
  theme
}) => `
  && {
    padding-left:  ${theme.space['600']};
    background-color:
      ${theme.color['fill-surface-raised']};
  }
`);
const InsetTable = styled(UITable)(({
  theme
}) => `
  && {
    border-left: 1px solid ${theme.color['border-primary-subtle']};

    > tbody > tr:first-child {
      td {
        border: none;
      }
    }
  }
`);
const RevisionRollupInsetTable = ({
  revisions,
  onRevisionSelect
}) => {
  return /*#__PURE__*/_jsx(InsetTableWrapper, {
    children: /*#__PURE__*/_jsxs(InsetTable, {
      condensed: true,
      flush: true,
      bordered: false,
      children: [/*#__PURE__*/_jsxs("colgroup", {
        children: [/*#__PURE__*/_jsx("col", {}), /*#__PURE__*/_jsx("col", {
          style: {
            width: ALIGNED_TIMESTAMP_COLUMN_WIDTH
          }
        })]
      }), /*#__PURE__*/_jsx("tbody", {
        children: pairUp(revisions).map(([revision, nextRevision], key) => {
          return /*#__PURE__*/_jsx(RevisionRollupInsetTableRow, {
            flowId: revision.flow.flowId,
            version: revision.version,
            timestamp: revision.timestamp,
            eventTypes: getAuditEventTypes(nextRevision, revision),
            onRevisionSelect: onRevisionSelect
          }, key);
        })
      })]
    })
  });
};
export default RevisionRollupInsetTable;